/** One side of the result's players row: avatar + name + colour. */
import React from 'react';
import {StyleSheet, View} from 'react-native';

import {Avatar, Txt} from '../../ui';

export type SeatProps = {
  name: string;
  colorLabel: string;
  mine: boolean;
  align: 'left' | 'right';
};

export default React.memo(function SeatView({
  name,
  colorLabel,
  mine,
  align,
}: SeatProps) {
  const avatar = (
    <Avatar key="avatar" name={name} size="md" tone={mine ? 'ev' : 'alt'} />
  );
  const text = (
    <View key="text" style={align === 'right' ? styles.textRight : undefined}>
      <Txt variant="seatName" numberOfLines={1}>
        {name}
      </Txt>
      <Txt variant="captionTight" tone="muted">
        {colorLabel}
      </Txt>
    </View>
  );
  return (
    <View style={[styles.seat, align === 'right' && styles.seatRight]}>
      {align === 'right' ? [text, avatar] : [avatar, text]}
    </View>
  );
});

const styles = StyleSheet.create({
  seat: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    flex: 1,
    minWidth: 0,
  },
  seatRight: {
    justifyContent: 'flex-end',
  },
  textRight: {
    alignItems: 'flex-end',
  },
});
